module.exports = __webpack_public_path__ + "img/vip_mb_tab_02.16e5acf9.png";